import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-party-size-reservation',
  templateUrl: './PartySizeReservation.html',
  styleUrls: ['./PartySizeReservation.scss']
})
export class PartySizeReservation implements OnInit {
  public countryData: string[] = [];

  constructor(
    private navParams: NavParams,
    private popoverController: PopoverController
  ) {}

  ngOnInit() {
    this.countryData = this.navParams.get('countryData') || ['1','2','3','4','5','6','7','8','9','10'];
  }

  addToCartClicked(country: string) {
    this.popoverController.dismiss(country);
  }
}
